import { DefinedUseQueryResult, useQuery, UseQueryOptions } from "@tanstack/react-query";


export const useGetRequestQuery = <T>(
    queryKey: string | any[],
    queryFn: () => Promise<T>,
    options: any
): DefinedUseQueryResult<T, Error> => {
    return useQuery<T>({
        queryKey,
        queryFn,
        onSuccess: (data: T) => {
            options.onSuccess?.(data);
        },
        onError: (error: unknown) => {
            options.onError?.(error);
        },
        ...options,
    });
};